import { gql } from "@apollo/client"; // saveVisitaEnteral.js


const SAVE_VISITA_ENTERAL = gql`
  mutation saveVisitaEnteral($input: AddVisitaEnteralInput!) {
    saveVisitaEnteral(input: $input) {
      idVisita
      idVisitaEnteral
    }
  }
`;

export default SAVE_VISITA_ENTERAL;

export const adaptAddVisitaEnteralInput = (data) => ({
  idVisitaEnteral: data?.idVisitaEnteral,
  idComboRIValorKarnofsky: data?.idComboRIValorKarnofsky,
  ingestaOral: !!data?.ingestaOral,
  idComboRIValorTipoAcceso: data?.idComboRIValorTipoAcceso,
  cambioSNGoSOG: !!data?.cambioSNGoSOG,
  justificacionCambioSNGoSOG: data?.justificacionCambioSNGoSOG,
  accesoEnteral: !!data?.accesoEnteral,
  justificacionAccesoEnteral: data?.justificacionAccesoEnteral,
  negativaGastrostomia: !!data?.negativaGastrostomia,
  justificacionNegativaGastrostomia: data?.justificacionNegativaGastrostomia,
  justificacionModificacion: data?.justificacionModificacion,
  idComboRIValorModoInfusion: data?.idComboRIValorModoInfusion,
  llevaBomba: !!data?.llevaBomba,
  formaPreparacion: data?.formaPreparacion,
  indicacionEspecial: data?.indicacionEspecial,
  flujo: data?.flujo,
  hidratacion: !!data?.hidratacion,
  indicacionHidratacion: data?.indicacionHidratacion,
  proteinasTotales: data?.proteinasTotales,
  caloriasTotales: data?.caloriasTotales,
  complicaciones: data?.complicaciones,
  listaIndicacion: data?.listaIndicacion?.map((item) => ({
    idInsumo: item?.idInsumo,
    cantidadDiaria: item?.cantidadDiaria
  })),
  idVisita: data?.idVisita
});